import { makeStyles } from '@mui/styles';
import {
  COLOR_BLUE,
  COLOR_PINK,
  COLOR_GRAY_20,
  COLOR_GRAY_90,
  COLOR_WHITE,
} from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  customSwitch: {
    width: 50,
    height: 35,
    padding: 7,
    marginLeft: 10,
    '& .MuiSwitch-switchBase': {
      margin: 7,
      padding: 3,
      transform: 'translateX(1px)',
      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(15px)',
        '& + .MuiSwitch-track': {
          backgroundColor: COLOR_PINK,
          opacity: 1,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 14,
      height: 14,
      borderRadius: '50%',
      backgroundColor: '#fff', // White circle for the thumb
      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
    },
    '& .MuiSwitch-track': {
      borderRadius: 34 / 2,
      backgroundColor: '#ddd',
      opacity: 1,
      transition: 'background-color 0.2s ease',
    },
  },
  switchContainer: {
    marginRight: 0,
  },
  outerWrapper: {
    padding: '100px 20px 0',
    maxWidth: 1088,
    margin: '0 auto',
    backgroundColor: COLOR_WHITE,
    fontFamily: 'Lato',

    [theme.breakpoints.up('md')]: {
      paddingLeft: 40,
      paddingRight: 40,
      maxWidth: 1168,
    },
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 0,
      paddingRight: 0,
      maxWidth: 1088,
    },
  },
  featureComparison: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },

  sectionHeading: {
    fontSize: 28,
    lineHeight: '40px',
    textAlign: 'center',
    color: COLOR_GRAY_90,
    fontWeight: 600,
  },

  plansSticky: {
    position: 'sticky',
    top: 0,
    paddingTop: 55,
    background: COLOR_WHITE,
    zIndex: 2,
  },
  // grid layout for the plans and features
  plansGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    gap: 20,
  },

  // Two column layout for China (Free + Researcher only)
  plansGridTwoCol: {
    gridTemplateColumns: '2fr 1fr 1fr',
  },

  empty: {
    fontSize: 30,
    lineHeight: '30px',
    color: 'var(--color-text-secondary)',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 30,
  },

  comparePlanCard: {
    padding: '32px 15px 40px',
    borderTopRightRadius: 24,
    borderTopLeftRadius: 24,
    minWidth: '250px',
  },
  free: {
    backgroundColor: '#FFFFFF',
  },
  researcher: {
    backgroundColor: '#FFF5F8',
  },
  prime: {
    backgroundColor: '#F4F7FF',
  },

  cardHeading: {
    fontSize: 20,
    lineHeight: '20px',
    marginBottom: 16,
    color: COLOR_GRAY_90,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
  },

  comparePrice: {
    fontWeight: 600,
    fontSize: 28,
    lineHeight: '30px',
    display: 'flex',
    alignItems: 'baseline',
    minHeight: 32,
    maxHeight: 32,
  },
  subDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: '#545454',
    marginLeft: theme.spacing(1),
  },

  freePricing: {
    minHeight: '142px',
    alignItems: 'flex-end',
  },

  freeCta: {
    padding: '13px 20px',
    width: '100%',
    background: 'transparent',
    display: 'block',
    textAlign: 'center',
    marginTop: 25,
    borderRadius: 48,
    border: `1.5px solid #616161`,
    color: '#545454',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '14px',
    textDecoration: 'none',
  },

  payBtn: {
    '&.loading': {
      pointerEvents: 'none',
      opacity: 0.8,
    },
    padding: '13px 20px',
    width: '100%',
    display: 'block',
    textAlign: 'center',
    borderRadius: 48,
    marginTop: 25,
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '14px',
    textDecoration: 'none',
  },
  payBtnPrimary: {
    color: '#fff',
    backgroundColor: COLOR_PINK,
  },

  payBtnSecondary: {
    color: COLOR_BLUE,
    backgroundColor: '#fff',
  },

  featureRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    borderBottom: `1px solid ${COLOR_GRAY_20}`,
    fontFamily: 'Lato',
    fontWeight: 400,
    fontSize: 18,
    lineHeight: '20px',
    color: COLOR_GRAY_90,
    gap: theme.spacing(2.5),
    '&:hover': {
      backgroundColor: '#D9E9FF',
      borderBottom: 'none',
      '& $featureValue': {
        backgroundColor: '#D9E9FF',
      },
    },
  },

  // Two column layout for China (Free + Researcher only)
  featureRowTwoCol: {
    gridTemplateColumns: '2fr 1fr 1fr',
  },

  featureName: {
    padding: '30px 20px 30px 30px',
    fontWeight: 500,
  },

  featureValue: {
    textAlign: 'center',
    padding: '30px 0',
    // minWidth: '325px',
  },

  productName: {
    fontFamily: 'Lato',
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '20px',
    color: COLOR_GRAY_90,
    padding: '15px 30px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: '#f0f2fa',
  },
  monthlyTag: {
    fontSize: 14,
    lineHeight: '14px',
    color: COLOR_GRAY_90,
    fontWeight: 400,
  },

  yearlyTag: {
    fontFamily: 'var(--font-family-inter-semibold)',
    fontSize: 'var(--font-size-base)',
    lineHeight: '24px',
    color: 'var(--color-text-primary)',
  },
  strikeOff: {
    textDecoration: 'line-through',
    marginLeft: theme.spacing(0.25),
    fontWeight: 400,
  },

  offerWrapper: {
    display: 'flex',
    alignItems: 'center',
  },

  offerTag: {
    background: '#d3f4c9',
    borderRadius: 6,
    fontFamily: 'var(--font-family-inter-semibold)',
    fontSize: 'var(--font-size-xs)',
    lineHeight: '24px',
    color: '#124d00',
    padding: '4px 10px',
    marginLeft: 12,
    position: 'relative',

    '&::before': {
      content: "''",
      position: 'absolute',
      width: 13,
      height: 13,
      transform: 'rotate(45deg)',
      top: 10,
      left: -4,
      background: '#d3f4c9',
      borderRadius: 4,
      zIndex: 0,
    },
  },

  skeleton: {
    width: '100%',
    span: {
      height: 32,
      margin: 0,
    },
  },

  // Additional styles for the toggle switch
  switch: {
    position: 'relative',
    display: 'inline-block',
    height: 30,
    width: 53,
    margin: 0,
  },

  switchInput: {
    opacity: 0,
    width: 0,
    height: 0,
  },

  slider: {
    backgroundColor: '#113dcd',
    position: 'absolute',
    cursor: 'pointer',
    inset: 0,
    transition: '0.4s',

    '&::before': {
      position: 'absolute',
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      content: "''",
      left: 3,
      bottom: 3,
      transition: 'all 0.3s ease-in',
    },
  },

  sliderRound: {
    borderRadius: 24,
    '&::before': {
      borderRadius: '100%',
    },
  },

  switchChecked: {
    background: '#113dcd',
    '& + $slider': {
      '&::before': {
        transform: 'translateX(23px)',
      },
    },
  },
  comparisonPlanDurationWrapper: {
    marginBottom: 20,
  },
  primeImage: {
    marginLeft: '8px',
    // marginTop: '30px',
  },

  // Switcher styles copied from PlanCard
  switchBox: {
    borderRadius: 6,
    border: '1px solid #EAECF0',
    padding: 6,
    display: 'inline-flex',
    gap: 6,
    marginBottom: theme.spacing(1.5),
  },
  switch: {
    color: '#616161', // COLOR_GRAY_70
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 500,
    borderRadius: 4,
    padding: theme.spacing(0, 1),
    cursor: 'pointer',
    textTransform: 'initial',

    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
      background: '#fff',
    },
  },
  activeSwitch: {
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
    backgroundColor: '#FFF',
  },
  activeSwitchBlue: {
    color: COLOR_PINK,
  },

  // Pricing display styles copied from PlanCard
  mainPriceValue: {
    fontWeight: 500,
    fontSize: '40px',
    lineHeight: '100%',
    color: COLOR_GRAY_90,
    fontFamily: 'Lato',
  },
  mainPriceMonth: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#616161', // COLOR_GRAY_70
    fontFamily: 'Lato',
  },
  noDiscountPrice: {
    display: 'block',
    color: '#616161',
    fontSize: '14px',
    textDecoration: 'line-through',
    fontFamily: 'Lato',
  },
  ctaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  bottomContainer: {
    marginBottom: '40px',
  },
  subDescription: {
    fontFamily: 'Lato',
    fontWeight: 400,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '32px',
  },
  freePrice: {
    fontFamily: 'Lato',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: 40,
    lineHeight: '30px',
    color: '#212121',
    letterSpacing: '4px',
  },
  noDiscountPriceNew: {
    color: '#616161',
    fontSize: '14px',
    textDecoration: 'line-through',
    fontFamily: 'Lato',
  },
}));
